import baseapi from "../baseAPI";
import {successMesg, errorMesg} from "./../../Pages/Toaster";

export const CollegeCallerDataAPI = async (setRecords, setLoading, currentPage, perpagedata, setPageCount, setCollegeList, setTeamList, setCallersList) =>
{
    
    setLoading(true);

    let txtsearchparam = "";

    /*if(filterparams !== "" && filterparams !== null && filterparams !== undefined)
    {
        txtsearchparam = `?${filterparams.toString()}`;
    }
    else
    {
        txtsearchparam = "?page=" + currentPage + "&per_page=" + perpagedata;
    }*/

    txtsearchparam = "?page=" + currentPage + "&per_page=" + perpagedata;

    try
    {
        const response = await baseapi.get("/api/sales/college-team-map" + txtsearchparam);
        
        //console.log("Data got successfully", response.data.data.data);

        setRecords(response.data.datalist.data);        
        //setCallersList();
        setTeamList(response.data.teamlist);
        setCollegeList(response.data.collegedatalist);
        setLoading(false);
        if(response.data.datalist.data.length > 0)
        {
            console.log('Total count====='+response.data.leadcount);
            let pagecount = Math.ceil(response.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }

    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    };
}

export const AddCollegeMappingAPI = async (formdata, setBtnSubmitLoader, setIsLeadAddModal, resetCollegeForm, setIsReloadRecords) =>
{
    //setLoading(true);

    console.log("Under API key===" + JSON.stringify(formdata));

    try 
    {
        const response = await baseapi.post('api/sales/college-team-map/add', formdata);

        //console.log("Data got successfully", response);

        /*setNewLeadCount(response.data.freshleads);
        setPendingFollowupCount(response.data.totalfollowup);
        setTodayFollowupCount(response.data.dashboard.todayfollowup);*/

        if(response.data.code === 200)
        {
            successMesg("College mapping has been done successfully.");
            setBtnSubmitLoader(false);
            setIsLeadAddModal(false);
            resetCollegeForm();
            setIsReloadRecords(true);
        }
        else
        {
            setBtnSubmitLoader(false);
            setIsLeadAddModal(false);
            resetCollegeForm();
            setIsReloadRecords(true);
        }

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        
        errorMesg("College mapping has not been copleted. Please try again!!!");

        setBtnSubmitLoader(false);
    }
}

export const CallerDataLoadAPI = async (teamid, setCallersList) =>
{

    try
    {
        const response = await baseapi.get("/api/sales/team/" + teamid  +"/callerlist");
        
        //console.log("Data got successfully", response.data.data.data);

        setCallersList(response.data.datalist);

    }
    catch(error)
    {
        console.error("Error in user list:", error);
    };
}


